import { useAuth } from '../components/AuthProvider';

export function useIsBoard() {
  const { roles } = useAuth();
  return roles.includes('board');
}
